"use client"

import type { ReactNode } from "react"

import { CoviMount } from "../components/CoviMount"
import { CoviProvider } from "../contexts/CoviContext"

/**
 * App-shell-level mount for the Coval Agent (Sofia).
 *
 * Mounted directly inside `_app.tsx` ABOVE the per-page `getLayout()` boundary
 * so the agent panel state (open / closed, chat items) survives client-side
 * navigation between pages. Page components each wrap themselves in
 * `LogInRequired` → `DefaultLayout`, so any provider mounted inside the
 * layout chain would unmount on every navigation.
 *
 * Sofia is generally available to authenticated users. Capability-specific
 * rollouts, such as streaming transport, remain gated where they are used.
 */
export function AppCoviShellRoute({ children }: { children: ReactNode }) {
  return (
    <CoviProvider>
      {children}
      <CoviMount />
    </CoviProvider>
  )
}
